const createPalette = (tokens)=>({
        primary: {
            main: tokens.colors.original.brand.primary,
            dark: tokens.colors.original.brand.tertirary,
            light: tokens.colors.original.brand.secondary,
            contrastText: tokens.colors.text.dark.primary,
            quaternary: tokens.colors.original.brand.quaternary
        },
        secondary: {
            main: tokens.colors.accent.text.error,
            contrastText: tokens.colors.text.dark.primary
        },
        error: {
            main: tokens.colors.accent.text.error,
            light: tokens.colors.accent.bg.error,
            stroke: tokens.colors.accent.stroke.error,
            hover: tokens.colors.stroke.hover,
            dark: tokens.colors.stroke.error
        },
        success: {
            main: tokens.colors.accent.text.success,
            light: tokens.colors.accent.bg.success,
            stroke: tokens.colors.accent.stroke.success
        },
        review: {
            main: tokens.colors.accent.text.review,
            light: tokens.colors.accent.bg.review,
            stroke: tokens.colors.accent.stroke.review
        },
        warning: {
            main: tokens.colors.accent.text.warning,
            light: tokens.colors.accent.bg.warning,
            stroke: tokens.colors.accent.stroke.warning
        },
        blue: {
            main: tokens.colors.accent.text.blue,
            light: tokens.colors.accent.bg.blue,
            stroke: tokens.colors.accent.stroke.blue
        },
        background: {
            paper: tokens.colors.bg.light.primary,
            default: tokens.colors.bg.light.secondary,
            primary: tokens.colors.original.brand.secondary,
            lightPrimary: tokens.colors.bg.light.primary,
            lightSecondary: tokens.colors.bg.light.secondary,
            darkPrimary: tokens.colors.bg.dark.primary,
            darkSecondary: tokens.colors.bg.dark.secondary,
            greyscalePrimary: tokens.colors.bg.greyscale.primary,
            greyscaleSecondary: tokens.colors.bg.greyscale.secondary,
            greyscaleTertiary: tokens.colors.bg.greyscale.tertirary,
            gradientPurple: '#8349ff'
        },
        text: {
            primary: tokens.colors.text.light.primary,
            secondary: tokens.colors.text.light.secondary,
            tertiary: tokens.colors.text.light.tertirary,
            disabled: tokens.colors.text.light.tertirary
        },
        stroke: {
            primary: tokens.colors.stroke.primary,
            secondary: tokens.colors.stroke.secondary,
            tertiary: tokens.colors.stroke.tertirary,
            error: tokens.colors.stroke.error,
            hover: tokens.colors.stroke.hover
        }
    });
export { createPalette };
